<template>
  <div>
    <div class="query-container space-between">
      <div>
        <el-form size="small" :inline="true">
          <el-form-item label="统计时间：">
            <el-date-picker value-format="yyyy-MM-dd" v-model="param.startDate" type="date"
              placeholder="选择日期"></el-date-picker></el-form-item>

          <el-form-item>
            <el-date-picker value-format="yyyy-MM-dd" v-model="param.endDate" type="date"
              placeholder="选择日期"></el-date-picker>
          </el-form-item>

          <el-form-item label="车队：" prop="teamId">
            <el-select v-model="param.teamId" clearable placeholder="全部" style="width: 100%">
              <el-option v-for="item in teamOpts" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button style="width: 100px; margin-right: 20px" type="primary" @click="query">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="container">
      <div class="top">
        <div class="box">
          <div class="b2">重大违规</div>
          <div class="b3">
            <div class="left">确责 {{ data.seriousSummary.verifiedTimes }}</div>
            <div class="right">总数 {{ data.seriousSummary.totalTimes }}</div>
          </div>
        </div>

        <div class="box">
          <div class="b2">投诉差评</div>
          <div class="b3">
            <div class="left">确责 {{ data.complaintSummary.verifiedTimes }}</div>
            <div class="right">总数 {{ data.complaintSummary.totalTimes }}</div>
          </div>
        </div>

        <div class="box">
          <div class="b2">沟通违规</div>
          <div class="b3">
            <div class="left">确责 {{ data.communicationSummary.verifiedTimes }}</div>
            <div class="right">总数 {{ data.communicationSummary.totalTimes }}</div>
          </div>
        </div>

        <div class="box">
          <div class="b2">安全违规</div>
          <div class="b3">
            <div class="left">确责 {{ data.safetySummary.verifiedTimes }}</div>
            <div class="right">总数 {{ data.safetySummary.totalTimes }}</div>
          </div>
        </div>

        <div class="box">
          <div class="b2">服务违规</div>
          <div class="b3">
            <div class="left">确责 {{ data.serviceSummary.verifiedTimes }}</div>
            <div class="right">总数 {{ data.serviceSummary.totalTimes }}</div>
          </div>
        </div>

        <div class="box">
          <div class="b2">管理违规</div>
          <div class="b3">
            <div class="left">确责 {{ data.managementSummary.verifiedTimes }}</div>
            <div class="right">总数 {{ data.managementSummary.totalTimes }}</div>
          </div>
        </div>

        <div class="box">
          <div class="b2">操作违规</div>
          <div class="b3">
            <div class="left">确责 {{ data.operateSummary.verifiedTimes }}</div>
            <div class="right">总数 {{ data.operateSummary.totalTimes }}</div>
          </div>
        </div>
      </div>

      <div class="bottom">
        <el-table :data="data.list" stripe max-height="480" v-if="type === 1">
          <el-table-column label="序号" type="index" width="60"></el-table-column>

          <el-table-column prop="driverNo" sortable label="编号" width="80"></el-table-column>
          <el-table-column prop="driverName" label="姓名" width="70"></el-table-column>
          <el-table-column sortable prop="totalOrderNum" label="总单" width="80"></el-table-column>
          <el-table-column sortable prop="totalEvaluationNum" label="总评价" width="90"></el-table-column>

          <el-table-column prop="goodEvaluationRate" sortable label="好评率" width="100">
            <template slot-scope="scope">
              <div>{{ scope.row.goodEvaluationRate }} %</div>
            </template>
          </el-table-column>

          <el-table-column sortable prop="totalGoodEvaluationNum" label="5星" width="80"></el-table-column>

          <el-table-column sortable prop="totalPunishPoints" label="扣分" width="80"></el-table-column>

          <el-table-column sortable prop="complaints" label="投诉" width="80"
            :sort-method="sortByTotalTimes('complaints')">
            <template slot-scope="scope">
              <div>
                {{ scope.row.complaints.verifiedTimes }} /
                {{ scope.row.complaints.totalTimes }}
              </div>
            </template>
          </el-table-column>
          <el-table-column sortable prop="badEvaluation" label="差评" width="80"
            :sort-method="sortByTotalTimes('badEvaluation')">
            <template slot-scope="scope">
              <div>
                {{ scope.row.badEvaluation.verifiedTimes }} /
                {{ scope.row.badEvaluation.totalTimes }}
              </div>
            </template>
          </el-table-column>
          <el-table-column sortable prop="blacklist" label="拉黑" width="80" :sort-method="sortByTotalTimes('blacklist')">
            <template slot-scope="scope">
              <div>
                {{ scope.row.blacklist.verifiedTimes }} / {{ scope.row.blacklist.totalTimes }}
              </div>
            </template>
          </el-table-column>

          <el-table-column sortable prop="badDrive" label="不平稳" width="90" :sort-method="sortByTotalTimes('badDrive')">
            <template slot-scope="scope">
              <div>
                {{ scope.row.badDrive.verifiedTimes }} / {{ scope.row.badDrive.totalTimes }}
              </div>
            </template>
          </el-table-column>

          <el-table-column sortable prop="seriousSummary" label="重大违规"
            :sort-method="sortByTotalTimes('seriousSummary')">
            <template slot-scope="scope">
              <div>
                {{ scope.row.seriousSummary.totalVerifiedTimes }} /
                {{ scope.row.seriousSummary.totalTimes }}
                <el-button type="text" @click="showDetail(scope.row.seriousSummary.items)">详情</el-button>
              </div>
            </template>
          </el-table-column>

          <el-table-column sortable prop="serviceSummary" label="服务违规"
            :sort-method="sortByTotalTimes('serviceSummary')">
            <template slot-scope="scope">
              <div>
                {{ scope.row.serviceSummary.totalVerifiedTimes }} /
                {{ scope.row.serviceSummary.totalTimes }}
                <el-button type="text" @click="showDetail(scope.row.serviceSummary.items)">详情</el-button>
              </div>
            </template>
          </el-table-column>

          <el-table-column sortable prop="managementSummary" label="管理违规"
            :sort-method="sortByTotalTimes('managementSummary')">
            <template slot-scope="scope">
              <div>
                {{ scope.row.managementSummary.totalVerifiedTimes }} /
                {{ scope.row.managementSummary.totalTimes }}
                <el-button type="text" @click="showDetail(scope.row.managementSummary.items)">详情</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column sortable prop="safetySummary" label="安全违规" :sort-method="sortByTotalTimes('safetySummary')">
            <template slot-scope="scope">
              <div>
                {{ scope.row.safetySummary.totalVerifiedTimes }} /
                {{ scope.row.safetySummary.totalTimes }}
                <el-button type="text" @click="showDetail(scope.row.safetySummary.items)">详情</el-button>
              </div>
            </template>
          </el-table-column>

          <el-table-column sortable prop="communicationSummary" label="沟通违规"
            :sort-method="sortByTotalTimes('communicationSummary')">
            <template slot-scope="scope">
              <div>
                {{ scope.row.communicationSummary.totalVerifiedTimes }} /
                {{ scope.row.communicationSummary.totalTimes }}
                <el-button type="text" @click="showDetail(scope.row.communicationSummary.items)">详情</el-button>
              </div>
            </template>
          </el-table-column>

          <el-table-column sortable prop="operateSummary" label="操作违规"
            :sort-method="sortByTotalTimes('operateSummary')">
            <template slot-scope="scope">
              <div>
                {{ scope.row.operateSummary.totalVerifiedTimes }} /
                {{ scope.row.operateSummary.totalTimes }}
                <el-button type="text" @click="showDetail(scope.row.operateSummary.items)">详情</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-table :data="data.list" stripe max-height="480" v-if="type === 3">
          <el-table-column label="序号" type="index" width="100"></el-table-column>

          <el-table-column prop="driverNo" label="司机编号"></el-table-column>
          <el-table-column prop="driverName" label="司机姓名"></el-table-column>
          <el-table-column prop="totalOrders" label="总接单数"></el-table-column>

          <el-table-column prop="totalOperate" label="全部操作"></el-table-column>
          <el-table-column prop="totalBadOperate" label="不合规操作"></el-table-column>
          <el-table-column prop="scoreComplaint" label="出发">
            <template slot-scope="scope">
              {{ scope.row.goodStep1 }}/{{ scope.row.badStep1 }}
            </template>
          </el-table-column>
          <el-table-column prop="scoreComplaint" label="到达">
            <template slot-scope="scope">
              {{ scope.row.goodStep2 }}/{{ scope.row.badStep2 }}
            </template>
          </el-table-column>
          <el-table-column prop="scoreComplaint" label="上车">
            <template slot-scope="scope">
              {{ scope.row.goodStep3 }}/{{ scope.row.badStep3 }}
            </template>
          </el-table-column>
          <el-table-column prop="scoreComplaint" label="下车">
            <template slot-scope="scope">
              {{ scope.row.goodStep4 }}/{{ scope.row.badStep4 }}
            </template>
          </el-table-column>
          <el-table-column prop="scoreComplaint" label="完成">
            <template slot-scope="scope">
              {{ scope.row.goodStep5 }}/{{ scope.row.badStep5 }}
            </template>
          </el-table-column>
          <el-table-column prop="verifiedComplaintTimes" label="不合规率">
            <template slot-scope="scope">
              <div v-if="scope.row.totalOperate != 0">
                {{ ((scope.row.totalBadOperate / scope.row.totalOperate) * 100) | numFormat(0) }}
                %
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="scoreComplaint" label="合计服务分"></el-table-column>
        </el-table>

        <el-table :data="data.list" stripe max-height="480" v-if="type === 4">
          <el-table-column label="序号" type="index" width="100"></el-table-column>

          <el-table-column prop="driverNo" label="司机编号"></el-table-column>
          <el-table-column prop="driverName" label="司机姓名"></el-table-column>
          <el-table-column prop="totalOrders" label="总接单数"></el-table-column>
          <el-table-column prop="totalOrders" label="车型">
            <template slot-scope="scope">
              {{ scope.row.vehicleType | enumTransfer(vehicleTypeOpts, "id", "content") }}
            </template>
          </el-table-column>
          <el-table-column prop="goodDuration" label="优秀路程时长" width="140">
            <template slot-scope="scope"> {{ scope.row.goodDuration }}次 </template>
          </el-table-column>
          <el-table-column prop="commonDuration" label="合格路程时长" width="140">
            <template slot-scope="scope"> {{ scope.row.commonDuration }}次 </template>
          </el-table-column>
          <el-table-column prop="badDuration" label="不合格路程时长" width="140">
            <template slot-scope="scope"> {{ scope.row.badDuration }}次 </template>
          </el-table-column>

          <el-table-column prop="accuratelyDurationNum" label="有效考核次数"></el-table-column>

          <el-table-column prop="duration" label="平均接单时长">
            <template slot-scope="scope">
              {{
                (scope.row.totalDuration / scope.row.accuratelyDurationNum / 3600) | numFormat(1)
              }}
            </template>
          </el-table-column>
          <el-table-column prop="scoreDuration" label="合计服务分"></el-table-column>
        </el-table>

        <el-table :data="data.list" stripe max-height="480" v-if="type === 7">
          <el-table-column label="序号" type="index" width="100"></el-table-column>

          <el-table-column prop="driverNo" label="司机编号"></el-table-column>
          <el-table-column prop="driverName" label="司机姓名"></el-table-column>
          <el-table-column prop="totalOrders" label="总接单数"></el-table-column>

          <el-table-column prop="totalOntime" label="有效考核"></el-table-column>
          <el-table-column prop="badOntime" label="不合格"></el-table-column>
          <el-table-column prop="commonOntime" label="合格"></el-table-column>
          <el-table-column prop="goodOntime" label="优秀"></el-table-column>

          <el-table-column prop="verifiedComplaintTimes" label="不合格率">
            <template slot-scope="scope">
              <div v-if="scope.row.totalOntime != 0">
                {{ ((scope.row.badOntime / scope.row.totalOntime) * 100) | numFormat(0) }}
                %
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="scoreOntime" label="合计服务分"></el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 详情弹框 -->
    <el-dialog title="详情" :visible.sync="detailDialogVisible" width="600px" :close-on-click-modal="false">
      <el-table :data="detailList" stripe max-height="400">
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column prop="name" label="违规类型" width="150"></el-table-column>
        <el-table-column prop="verifiedTimes" label="确责次数" width="120"></el-table-column>
        <el-table-column prop="totalTimes" label="总次数" width="100"></el-table-column>

        <el-table-column label="确责率" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.totalTimes > 0">
              {{ ((scope.row.verifiedTimes / scope.row.totalTimes) * 100) | numFormat(1) }}%
            </span>
            <span v-else>0%</span>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getServiceSummary } from "@/api";
import config from "@/config/config";
import { DateUtil } from "@/util";

export default {
  components: {},
  props: {
    value: Object
  },
  created() {
    this.query();
  },
  mounted() { },
  watch: {},
  computed: {
    ...mapState({
      vehicleTypeOpts: (state) => state.vehicleTypeOpts,
      size: (state) => state.btnSize,
      teamOpts: (state) => state.teamOpts
    })
  },
  data() {
    return {
      type: 1,
      items: [
        { name: "路程时长", field: "durationScore" },
        { name: "超载", field: "overLoad" },
        { name: "玩手机", field: "playPhone" },
        { name: "不带耳机通话", field: "noHeadphones" },
        { name: "疲劳驾驶", field: "tiredness" },
        { name: "其他", field: "others" }
      ],
      param: {
        startDate: DateUtil.getDayStr(-30),
        endDate: DateUtil.getDayStr(0),
        teamId: config.initTeam,
        period: "day"
      },
      data: {},
      // 详情弹框相关
      detailDialogVisible: false,
      detailList: []
    };
  },
  methods: {
    query() {
      getServiceSummary(this.param).then((res) => {
        this.data = res.data;
      });
    },

    chooseType(type) {
      this.type = type;
    },

    // 自定义排序方法 - 按路径6时长排序
    sortByPath6Duration(a, b) {
      const aPath6 = a.routeDurationDataList?.find((item) => item.pathId === 6);
      const bPath6 = b.routeDurationDataList?.find((item) => item.pathId === 6);

      const aValue = aPath6?.avgTotalTime || 0;
      const bValue = bPath6?.avgTotalTime || 0;

      return aValue - bValue;
    },

    // 通用排序方法 - 按指定字段的 totalTimes 排序
    sortByTotalTimes(fieldName) {
      return (a, b) => {
        const aValue = a[fieldName]?.totalTimes || 0;
        const bValue = b[fieldName]?.totalTimes || 0;
        return aValue - bValue;
      };
    },

    showDetail(items) {
      this.detailList = items || [];
      this.detailDialogVisible = true;
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  padding: 10px;

  .top {
    display: flex;
    justify-content: space-around;

    .box {
      width: 200px;
      height: 100px;
      background: #ffffff;
      box-shadow: 2px 2px 10px rgba(201, 200, 197, 0.85);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      color: #333;
      cursor: pointer;

      &.active {
        background-color: #4894efc7;
        color: white;
      }

      .b1 {
        font-size: 18px;
      }

      .b2 {
        font-weight: bold;
        font-size: 18px;
      }

      .b3 {
        display: flex;
        justify-content: space-around;
        font-size: 14px;
        width: 100%;
      }
    }
  }

  .bottom {
    padding: 20px;
    margin-top: 20px;
  }

  // 时长考评样式 - 内联展示
  .duration-inline-container {
    .duration-inline-item {
      display: flex;
      align-items: center;
      margin-bottom: 4px;
      font-size: 12px;
      line-height: 1.4;

      &:last-child {
        margin-bottom: 0;
      }

      .path-id {
        font-weight: bold;
        color: #409eff;
        margin-right: 8px;
        min-width: 50px;
      }

      .duration-data {
        color: #606266;
        flex: 1;

        .separator {
          color: #c0c4cc;
          margin: 0 6px;
        }

        .value {
          color: #303133;
          font-weight: 600;

          &.text-danger {
            color: #f56c6c;
          }
        }
      }
    }
  }

  .no-data {
    color: #909399;
    font-size: 12px;
    text-align: center;
    padding: 10px;
  }
}
</style>
